import { path, pathEq } from "ramda";
import { Channel, ChannelPayloadFilter } from "spyne";

export class ChannelMenuDrawer extends Channel {
  constructor(name, props = {}) {
    name = "CHANNEL_MENU_DRAWER";
    props.sendCachedPayload = true;
    super(name, props);
    this.props.showMenu = false;
  }

  onRegistered() {
    const breakPointFilter = new ChannelPayloadFilter({
      mediaQueryName: "showMenuDrawer",
    });

    const menuDrawerBtnFilter = new ChannelPayloadFilter({
      propFilters: {
        eventType: "menuDrawer",
      },
    });

    const menuDrawerRouteFilter = new ChannelPayloadFilter({
      propFilters: {
        action: (val) => val !== "CHANNEL_ROUTE_CONFIG_UPDATED_EVENT",
        payload: pathEq(["routeData", "eventType"], "menuDrawer"),
      },
    });

    const win$ = this.getChannel("CHANNEL_WINDOW", breakPointFilter);
    win$.subscribe(this.onWindowEvent.bind(this));

    const ui$ = this.getChannel("CHANNEL_UI", menuDrawerBtnFilter);
    ui$.subscribe(this.onUiClick.bind(this));

    const route$ = this.getChannel("CHANNEL_ROUTE", menuDrawerRouteFilter);
    route$.subscribe(this.onUiClick.bind(this));

    const appRoute$ = this.getChannel("CHANNEL_APP_ROUTE");
    appRoute$.subscribe(this.onAppRouteEvent.bind(this));
  }

  onAppRouteEvent(e) {
    this.sendMenuDrawerEvent(false);
  }

  onUiClick(e) {
    const { isHamburger } = e.payload;
    const checkBurgerClassFn = path(["srcElement", "el", "classList"], e);
    const isHamburgerBtn = isHamburger === "true";
    const showBurgerBool = checkBurgerClassFn.contains("open") === false;
    if (isHamburgerBtn === true) {
      this.sendMenuDrawerEvent(showBurgerBool);
    } else {
      this.sendMenuDrawerEvent(false);
    }
  }

  sendMenuDrawerEvent(b = true) {
    const action =
      b === true
        ? "CHANNEL_MENU_DRAWER_SHOW_EVENT"
        : "CHANNEL_MENU_DRAWER_HIDE_EVENT";
    this.sendChannelPayload(action, { action });
  }

  onWindowEvent(e) {
    const { payload } = e;
    const { matches } = payload;
    if (matches === false) {
      this.sendMenuDrawerEvent(matches);
    }
  }

  addRegisteredActions() {
    return ["CHANNEL_MENU_DRAWER_SHOW_EVENT", "CHANNEL_MENU_DRAWER_HIDE_EVENT"];
  }

  onViewStreamInfo(obj) {
    //let data = obj.props();
  }
}
